/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';

import {
	itemSkeletonCSS,
	avatarSkeletonCSS,
	labelSkeletonCSS,
	type AvatarShape,
} from './search-skeleton.styled';

export type AvatarShapeWithNone = 'none' | AvatarShape | AvatarShape[];

export type SkeletonItemProps = {
	avatarShape?: AvatarShapeWithNone;
	width?: number;
	isShimmering?: boolean;
	/**
	 * The text height that the skeleton is intended to represent.
	 * The actual skeleton will be approximately half of this height by design.
	 */
	textHeight?: number;
};

export const SkeletonItem = ({
	avatarShape = 'none',
	width,
	isShimmering,
	textHeight,
}: SkeletonItemProps) => {
	const avatarShapes: AvatarShape[] = Array.isArray(avatarShape)
		? avatarShape
		: ([avatarShape] as AvatarShape[]);
	return (
		// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		<div css={itemSkeletonCSS}>
			{avatarShape !== 'none'
				? // eslint-disable-next-line react/no-array-index-key
					avatarShapes.map((shape, idx) => (
						// @ts-ignore
						// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
						<span key={idx} css={avatarSkeletonCSS(shape, isShimmering)} />
					))
				: null}
			{/* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */}
			<span css={labelSkeletonCSS(width, isShimmering, textHeight)} />
		</div>
	);
};
